// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Vimeo_wrapper__o1IQF","in":"Vimeo_in__ZFwUF"};